import { InsuranceCarrier, insuranceCarrierDefs } from '@shared';

const carrierName = (carrier: InsuranceCarrier) =>
  insuranceCarrierDefs[carrier].name.toLowerCase();

/**
 * Carriers with no `/logos/<lowercased-name>.svg`. Both ship raster art only,
 * so without an entry here the derived path 404s and the badge renders broken.
 * ManhattanLife resolves to the square Lady Liberty mark rather than the full
 * lockup — this badge is a small square, and the wordmark is illegible in it.
 */
const EXPLICIT_LOGO_SRC: Record<string, string> = {
  [carrierName(InsuranceCarrier.NewYorkLife)]: '/logos/nyl-logo.png',
  [carrierName(InsuranceCarrier.ManhattanLife)]: '/logos/manhattanlife-mark.png',
};

/**
 * Resolves the small square carrier mark shown in product/quote badges. Most
 * carriers have a `/logos/<lowercased-name>.svg`; the rest are listed above.
 *
 * Note this is a separate lookup from `insuranceCarrierDefs[...].image`, which
 * feeds the comparison modal and PUI dialogs with the wide lockup. A carrier
 * needs BOTH to render everywhere.
 */
export function getCarrierLogoSrc(carrierName?: string | null): string {
  const name = carrierName?.toLowerCase() ?? '';
  return EXPLICIT_LOGO_SRC[name] ?? `/logos/${name}.svg`;
}
